var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1637_4093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 14.7739V3.21832C9 1.99102 8.00508 0.996094 6.77778 0.996094H3.22222C1.99492 0.996094 1 1.99102 1 3.21832V14.7739C1 16.0012 1.99492 16.9961 3.22222 16.9961H6.77778C8.00508 16.9961 9 16.0012 9 14.7739Z",
    stroke: "#303030",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0.996094C12.7909 0.996094 11 2.78695 11 4.99609C11 7.20523 12.7909 8.99609 15 8.99609C17.2091 8.99609 19 7.20523 19 4.99609C19 2.78695 17.2091 0.996094 15 0.996094Z",
    stroke: "#303030",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 14.3294V13.2183C18.8889 11.991 17.8939 10.9961 16.6666 10.9961H13.3333C12.106 10.9961 11.1111 11.991 11.1111 13.2183V14.3294C11.1111 15.5567 12.106 16.5516 13.3333 16.5516H16.6666C17.8939 16.5516 18.8889 15.5567 18.8889 14.3294Z",
    stroke: "#303030",
    strokeWidth: 1.11111
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1637_4093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white",
    transform: "translate(0 -0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPanel);
export default __webpack_public_path__ + "static/media/MyPanel.523a3b705a6ed5dcd598e57cd2a16f67.svg";
export { ForwardRef as ReactComponent };